// New Customer Intake mock data (approved HTML:
// 20-New-Customer-Intake-Consistency-Review-v5.html).
// Restricted path: there is no general search. The rep connects the
// caller via a phone number already on an account, or saves a genuinely
// new customer. Ambiguous identity holds for authorized resolution.

export interface IntakeDraft {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  referralName: string;
  horseNotes: string;
}

export const EMPTY_INTAKE: IntakeDraft = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'United States',
  referralName: '',
  horseNotes: '',
};

export const UNKNOWN_CALLER_PHONE = '(615) 555-0189';

export const CALL_INFO = {
  providerLabel: 'Kixie · Business Id 72616',
  providerEvidence: 'Example provider state',
  state: 'Connected',
  duration: '03:42',
  callerName: 'Incoming caller',
  callerNumber: UNKNOWN_CALLER_PHONE,
  initials: 'IC',
};
